<template>
  <v-container>
    <component :is="componentFromPath" />
  </v-container>
</template>

<script>
import TenantDetail from "./Details/TenantDetail.vue";
import PlanDetail from "./Details/PlanDetail.vue";

export default {
  components: {
    TenantDetail,
    PlanDetail,
  },

  data: () => ({
    componentMap: {
      tenants: "TenantDetail",
      plans: "PlanDetail",
    },
  }),

  computed: {
    componentFromPath() {
      return this.componentMap[this.$route.params.category];
    },
  },

  beforeMount() {
    if (!Object.keys(this.componentMap).includes(this.$route.params.category))
      this.$router.push("/");
  },
};
</script>
